// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"merchant-link-list-component_uk-open__7mhTt","grecaptcha-badge":"merchant-link-list-component_grecaptcha-badge__nnhjh","merchantLinkList":"merchant-link-list-component_merchantLinkList__i9Sst","listWrapper":"merchant-link-list-component_listWrapper__CD4sQ","titleItem":"merchant-link-list-component_titleItem__JJa7Z","icon":"merchant-link-list-component_icon__jMyhY","link":"merchant-link-list-component_link__Q6PSI"};
    if(module.hot) {
      // 1750775019848
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  